import script from "./Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=3ed7d48a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed7d48a"]])

export default __exports__